// @ts-nocheck
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { withRouter } from '../../../../router-compat';

import configs from '../configs';
import { IntegrationLayout } from '../_shared';
import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Switch from '../../../ui/Switch';
import Select from '../../../ui/Select';
import FormGroup from '../../../ui/FormGroup';

class GoogleAdwords extends Component {
  componentDidMount() {
    const { GoogleAdwords: ga } = this.props.store.integrations;
    ga.getConfigs().then(() => ga.getAudiences());
    ga.getAuthUrl();
    ga.resetInputConfigs();
    const { code, scope } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) {
      ga.setup(code, scope).then(() => this.props.history.replace(this.props.location.pathname));
    }
  }

  render() {
    const ga = this.props.store.integrations.GoogleAdwords;
    const {
      inputConfigs, authUrl, loading, handleInput, updateConfigs, anyLoading,
      audiences, configs: gaConfigs,
    } = ga;

    return (
      <IntegrationLayout config={configs.GoogleAdwords}>
        <Card padded className="mb-5">
          <CardHead title="Setup" />
          <ol className="m-0 pl-5 flex flex-col gap-2 text-[13px] leading-relaxed">
            <li>Log in to your Google Adwords account.</li>
            <li>
              <a href={authUrl} target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline font-medium">
                Authorize Movology
              </a>{' '}— grants Capture permissions to your account.
            </li>
            <li>After authorizing, the enabled toggle below should be on.</li>
            <li>Select the CRM_BASED audience for abandons in the dropdown below.</li>
            <li>You&apos;re all set — abandons will be added to your audience.</li>
          </ol>
        </Card>

        <Card padded>
          <CardHead
            title="Settings"
            action={(
              <div className="flex items-center gap-2">
                <span className="text-[12.5px] text-mov-ink-soft">Enabled</span>
                <Switch
                  checked={!!inputConfigs.enabled}
                  onChange={(v) => handleInput(null, { name: 'enabled', checked: v })}
                />
              </div>
            )}
          />
          <FormGroup label="Audience">
            <Select
              disabled={!inputConfigs.enabled || loading.getAudiences}
              value={inputConfigs.audienceIdx ?? ''}
              onChange={(e) => handleInput(null, { name: 'audienceIdx', value: Number(e.target.value) })}
            >
              <option value="">Select an audience…</option>
              {audiences.map((audience, i) => {
                const listType = _.startCase(audience['UserList.Type'] || audience.listType);
                const star = audience.id === gaConfigs.userListId ? '★ ' : '';
                return (
                  <option key={audience.id} value={i}>
                    {`${star}${audience.name} · ID ${audience.id} · ${listType}`}
                  </option>
                );
              })}
            </Select>
          </FormGroup>
          <div className="flex justify-end">
            <Button
              variant="primary"
              loading={anyLoading}
              disabled={anyLoading || (inputConfigs.enabled && inputConfigs.audienceIdx === undefined)}
              onClick={() => updateConfigs()}
            >
              Update settings
            </Button>
          </div>
        </Card>
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(GoogleAdwords)));
